// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kRY9","col":"styles_col__9TVXZ"};